module.exports = __webpack_public_path__ + "img/air_pm10.7699967c.svg";